<mat-form-field>
  <mat-label>{{ control.label }}</mat-label>
  <mat-select
    [formControl]="inputControl"
    [required]="isRequired"
    [errorStateMatcher]="errorStateMatcher"
    panelWidth="auto"
    panelClass="select-wrap-panel"
  >
    @for (option of control.customOptions?.selectOptions; track option) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
  @if (control.hintText) {
    <mat-hint class="hint">{{ control.hintText }}</mat-hint>
  }
</mat-form-field>
